import { useMemo } from "react";
import { Controller, useWatch, type Control } from "react-hook-form";

import type { ICampaignWizardForm } from "../../../../../../../../../../shared/types/form.type";
import { CompactSelect } from "../../../../../../../../../../shared/components/selects/compact-select/CompactSelect";
import { appStoreSelectItems } from "../../data/hard-lists";

// Відображення магазину в CompactSelect («none», як раніше)
export const CompactSelectAppStore = (props: {
	control: Control<ICampaignWizardForm>;
}) => {
	const appStore = useWatch({
		control: props.control,
		name: "campaign_context.campaign.app_store",
	});
	const value = useMemo(() => {
		const v = appStore ?? "";
		if (v === "GOOGLE_APP_STORE" || v === "APPLE_APP_STORE") return v;
		return "none";
	}, [appStore]);

	return (
		<Controller
			control={props.control}
			name='campaign_context.campaign.app_store'
			render={({ field }) => (
				<CompactSelect
					items={appStoreSelectItems}
					value={value}
					onSelect={(key) => field.onChange(key)}
					className={"field-item__select"}
					usePortal
				/>
			)}
		/>
	);
};
